module.exports = __webpack_public_path__ + "static/media/07-pistol-poem-pt2.cdaad343.mp3";